import React from 'react';
import { Layout } from 'antd';

import Content from '../../../components/Pages/LpReports/ProfileTemplate';
import { displayName } from '../../../config';

const LpReportTemplateProfile: React.FC = (): JSX.Element => {
  document.title = `${displayName}: LP Report Template Profile`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default LpReportTemplateProfile;
